import { Injectable } from '@angular/core';

import { rastreamentosRoute, rastreamentosStorage } from "./data.service";
import { AuthService } from "../../shared/services/auth.service";

@Injectable()
export class RastreamentoService {

    constructor(
        private _authService: AuthService
    ) { }

    goToSetting() {
        let router: string = rastreamentosRoute + '/configuracoes';
        this._authService.navigateTo(router);
    }

    goToMap() {
        let router: string = rastreamentosRoute + '/mapa';
        this._authService.navigateTo(router);
    }

    goToMap2() {
        let router: string = rastreamentosRoute + '/mapa2';
        this._authService.navigateTo(router);
    }

    goToVehicles() {
        let router: string = rastreamentosRoute + '/veiculos';
        this._authService.navigateTo(router);
    }

    goToHistoric(bemId: any) {
        let router: string = rastreamentosRoute + '/veiculos';
        this._authService.navigateTo(router, bemId);
    }

    //storage
    setSessionStorage(veiculoObject: any) {
        const object: string = JSON.stringify(veiculoObject);
        sessionStorage.setItem(rastreamentosStorage + '-rastrear', object);
    }

    getSessionStorage() {
        const item: string = sessionStorage.getItem(rastreamentosStorage + "-rastrear");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(rastreamentosStorage + "-rastrear");
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/shared/rastreamento.service.ts
 **/